import { ModuleIcon } from '@/components/ModuleIcon';
import { SiteFooter } from '@/components/SiteFooter';
import { useFlags } from '@/hooks/useFlags';
import styles from './MaintenanceGate.module.css';

export function MaintenanceGate({ children }: { children: React.ReactNode }) {
  const flags = useFlags();

  if (!flags.MAINTENANCE_MODE) return children;

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.icon}><ModuleIcon name="wrench" size={32} /></div>
        <h1 className={styles.title}>Be right back</h1>
        <p className={styles.body}>
          Doopey's World is getting a quick update. This usually only takes a few minutes.
        </p>
      </div>
      <SiteFooter className={styles.footer} adminCopyrightHoneypot />
    </div>
  );
}
